export const state = {
  ranking: null,
  position: 0,
};
